import CloseIcon from '@mui/icons-material/Close';
import { SxProps } from '@mui/material';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';

interface DismissibleAlertProps {
    sx?: SxProps;
    severity?: 'error' | 'warning' | 'info' | 'success';
    children: React.ReactNode;
}

export const DismissibleAlert: React.FC<DismissibleAlertProps> = ({ sx, severity, children }) => {
    const [open, setOpen] = React.useState(true);

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={open}>
                <Alert
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={sx}
                    severity={severity}
                >
                    {children}
                </Alert>
            </Collapse>
        </Box>
    );
};
